module.exports = __webpack_public_path__ + "img/pic_qianzhang@2x.fac7ec1b.png";